// extracted by mini-css-extract-plugin
export default {"root":"PlasmicTweetButton_root__ULMVM","svg":"PlasmicTweetButton_svg__IV210"};